import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const getDestinationsAPI = async (
  { pageIndex, skip },
  isLoading,
  accessJWT
) => {
  try {
    isLoading(true);

    const body = {
      skip: pageIndex + 1,
      limit: skip,
    };

    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/destinations/search`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    consoleLog([parsedResponseData, "response123"]);
    if (parsedResponseData && parsedResponseData.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getFilterDestinationsAPI = async (
  { searchQuery, pageIndex, limit, skip },
  payload,
  setIsLoading,
  accessJWT
) => {
  consoleLog([skip, limit, pageIndex, "ais"]);
  try {
    setIsLoading(true);

    const config = getHeaderConfig(null, accessJWT);

    const body = {
      ...payload,
      skip: pageIndex + 1,
      limit: limit,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/destinations/search`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      if (setIsLoading) setIsLoading(false);
      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    throw new Error("Error fetching data");
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  } finally {
    setIsLoading(false);
  }
};

export const createOrDestination = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/destinations`;
  try {
    if (isLoading) isLoading(true);

    const config = getHeaderConfig(null, accessJWT);
    const response = args?.id
      ? await axios.put(API_URL, encryptData(args), config)
      : await axios.post(API_URL, encryptData(args), config);

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      consoleLog([parsedResponseData, "response"]);
      return parsedResponseData?.data;
    } else {
      console.error("Unexpected status code:", parsedResponseData?.statusCode);
      return null;
    }
  } catch (error) {
    console.error("Error creating/updating destination:", error);
    return null;
  } finally {
    if (isLoading) isLoading(false);
  }
};

export const deleteDestinationsAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/destinations/${args.id}`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.delete(API_URL, config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData) {
      if (isLoading) isLoading(false);
      return parsedResponseData;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error deleting destinations:", error);
    return null;
  }
};
